var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { buildGeminiFilterPeriodTooltipLabels } from '@web/components/Apps/Gemini/geminiChartTooltipLabels';
import { ClickableGeminiUsageLevelLegend, formatGeminiUsageLevelLabel } from '@web/components/Apps/Gemini/geminiUsageLevel';
import { buildGeminiUsageLevelDistributionChartData, buildGeminiUsageLevelDistributionExportRows, GEMINI_USAGE_LEVEL_DISTRIBUTION_BAR_CHART_CONFIGS, GEMINI_USAGE_LEVEL_DISTRIBUTION_CURRENT_STACK_DATA_KEYS, GEMINI_USAGE_LEVEL_DISTRIBUTION_PREVIOUS_STACK_DATA_KEYS, GEMINI_USAGE_LEVEL_DISTRIBUTION_TEAM_STACK_DATA_KEYS, geminiUsageLevelDistributionDataKey } from '@web/components/Apps/Gemini/geminiUsageLevelDistributionChart';
import { GeminiUsageLevelDistributionUserTooltip } from '@web/components/Apps/Gemini/GeminiUsageLevelDistributionUserTooltip';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { ChartSeriesVisibility } from '@web/components/layout/RechartsItems/ChartSeriesVisibility';
import CustomTooltip from '@web/components/layout/RechartsItems/CustomTooltip';
import { createEdgePositionedBarTooltipContent } from '@web/components/layout/RechartsItems/EdgePositionedBarTooltip';
import { rechartsDiagonalStripeFillUrl, rechartsDiagonalStripePatternDefs } from '@web/components/layout/RechartsItems/rechartsDiagonalStripes';
import { renderStackedBarCells } from '@web/components/layout/RechartsItems/StackedBarCells';
import { Widget } from '@web/components/layout/Widget';
import { WidgetChartPlotArea } from '@web/components/layout/WidgetChartPlotArea/WidgetChartPlotArea';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { GEMINI_USAGE_LEVEL_COLORS_CONFIG } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled } from '@web/utility';
import { createPeriodComparisonSeriesLabelFormatter } from '@web/utility/ tooltip/periodComparisonTooltip';
import { ComparisonPeriod, navigateToEventsLogForApp, navigateToEventsLogFromChartPeriodForApp } from '@web/utility/chartNavigation';
import { getPeriodBarChartLayoutProps, isBarChartRowsEmpty } from '@web/utility/charts';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { ApplicationEnum, GeminiGroupedChartViewEnum, InsightTypeEnum } from '@workalizer/shared';
import { GEMINI_USAGE_LEVELS, isGeminiUsageLevelDistributionVisible } from '@workalizer/shared/lib/gemini-usage-level';
import { getPreviousPeriod } from '@workalizer/shared/utils';
import { useTranslation } from 'react-i18next';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
var I18N = 'app.apps.gemini.usageLevelDistribution';
var geminiUsageLevelDistributionTeamStripePatternId = function (dataKey) {
    return "".concat(InsightTypeEnum.geminiUsageLevelDistribution, "_").concat(dataKey);
};
export function GeminiUsageLevelDistribution() {
    var _this = this;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var _a = useFilters(), dateFrom = _a.dateFrom, dateTo = _a.dateTo, orgUnit = _a.orgUnit, user = _a.user;
    var isVisible = user == null && isGeminiUsageLevelDistributionVisible(dateFrom, dateTo);
    var _b = trpc.geminiUsageLevelDistribution.useQuery({
        dateFrom: dateFrom,
        dateTo: dateTo,
        orgUnitId: orgUnit,
        userId: user
    }, { enabled: isVisible }), data = _b.data, isLoading = _b.isLoading, refetch = _b.refetch;
    if (!isVisible) {
        return null;
    }
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var isPeriodView = data.view === GeminiGroupedChartViewEnum.PERIOD;
    var showTeamAverage = Boolean(user) &&
        isPeriodView &&
        data.segments.some(function (segment) { return segment.teamLevels != null; });
    var chartData = buildGeminiUsageLevelDistributionChartData(data.segments, {
        dateFrom: dateFrom,
        dateTo: dateTo,
        filterPeriodLabels: isPeriodView
            ? undefined
            : buildGeminiFilterPeriodTooltipLabels(dateFrom, dateTo)
    });
    var metricLabels = GEMINI_USAGE_LEVELS.reduce(function (acc, level) {
        acc[level.toLowerCase()] = formatGeminiUsageLevelLabel(level, true, t);
        return acc;
    }, {});
    var seriesLabelFormatter = createPeriodComparisonSeriesLabelFormatter(metricLabels);
    var tooltipSeriesOrder = showTeamAverage
        ? __spreadArray(__spreadArray(__spreadArray([], GEMINI_USAGE_LEVEL_DISTRIBUTION_BAR_CHART_CONFIGS.previous.map(function (config) { return config.dataKey; }), true), GEMINI_USAGE_LEVEL_DISTRIBUTION_BAR_CHART_CONFIGS.current.map(function (config) { return config.dataKey; }), true), GEMINI_USAGE_LEVEL_DISTRIBUTION_BAR_CHART_CONFIGS.team.map(function (config) { return config.dataKey; }), true) : __spreadArray(__spreadArray([], GEMINI_USAGE_LEVEL_DISTRIBUTION_BAR_CHART_CONFIGS.previous.map(function (config) { return config.dataKey; }), true), GEMINI_USAGE_LEVEL_DISTRIBUTION_BAR_CHART_CONFIGS.current.map(function (config) { return config.dataKey; }), true);
    var teamStripePatterns = showTeamAverage
        ? GEMINI_USAGE_LEVELS.map(function (level, index) { return ({
            patternId: geminiUsageLevelDistributionTeamStripePatternId(GEMINI_USAGE_LEVEL_DISTRIBUTION_BAR_CHART_CONFIGS.team[index].dataKey),
            chartColor: GEMINI_USAGE_LEVEL_COLORS_CONFIG[level].teamChartColor
        }); })
        : [];
    var stripeSwatchColors = showTeamAverage
        ? Object.fromEntries(GEMINI_USAGE_LEVEL_DISTRIBUTION_BAR_CHART_CONFIGS.team.map(function (config, index) { return [
            config.dataKey,
            GEMINI_USAGE_LEVEL_COLORS_CONFIG[GEMINI_USAGE_LEVELS[index]]
                .teamChartColor
        ]; }))
        : undefined;
    var _c = getPeriodBarChartLayoutProps({
        barGroupCount: chartData.length,
        barsPerGroup: showTeamAverage ? 3 : 2
    }), barGap = _c.barGap, barSize = _c.barSize, periodXAxis = _c.periodXAxis, periodBarChartMargin = _c.periodBarChartMargin;
    var chartPlotEmpty = isBarChartRowsEmpty(chartData);
    var isSingleUserPeriodView = isPeriodView && Boolean(user);
    var formatTooltipValue = function (value, dataKey, _label, row) {
        var _a;
        var level = GEMINI_USAGE_LEVELS.find(function (usageLevel) {
            return geminiUsageLevelDistributionDataKey('current', usageLevel) ===
                dataKey ||
                geminiUsageLevelDistributionDataKey('previous', usageLevel) ===
                    dataKey ||
                geminiUsageLevelDistributionDataKey('team', usageLevel) === dataKey;
        });
        if (!level || !row || !dataKey) {
            return "".concat(value, "%");
        }
        var section = dataKey.startsWith('team')
            ? 'team'
            : dataKey.startsWith('previous')
                ? 'previous'
                : 'current';
        var levelCounts = section === 'team'
            ? row.teamLevelCounts
            : section === 'previous'
                ? row.previousLevelCounts
                : row.levelCounts;
        var count = (_a = levelCounts === null || levelCounts === void 0 ? void 0 : levelCounts[level]) !== null && _a !== void 0 ? _a : 0;
        return "".concat(count, " ").concat(t(count === 1
            ? 'app.apps.gemini.adoptionTrend.user'
            : 'app.apps.gemini.adoptionTrend.users'), " (").concat(value, "%)");
    };
    var renderTooltip = createEdgePositionedBarTooltipContent(isSingleUserPeriodView ? (_jsx(GeminiUsageLevelDistributionUserTooltip, { t: t, showTeamAverage: showTeamAverage })) : (_jsx(CustomTooltip, { seriesOrder: tooltipSeriesOrder, periodComparisonTooltip: true, seriesLabelFormatter: seriesLabelFormatter, separatorAfterDataKeys: showTeamAverage
            ? [
                geminiUsageLevelDistributionDataKey('current', GEMINI_USAGE_LEVELS[GEMINI_USAGE_LEVELS.length - 1])
            ]
            : undefined, stripeSwatchColors: stripeSwatchColors, formatValue: formatTooltipValue })), chartData.length);
    var exportRows = buildGeminiUsageLevelDistributionExportRows(data, isPeriodView, t, I18N, showTeamAverage);
    var legendItems = GEMINI_USAGE_LEVELS.map(function (level) { return ({
        level: level,
        currentValue: "".concat(data.summary[level].share, "%"),
        diffValue: data.summary[level].previous,
        teamAverage: showTeamAverage ? data.summary[level].teamAverage : undefined
    }); });
    var navigateToGeminiEventsLog = function () {
        return navigateToEventsLogForApp({
            navigateTo: navigateTo,
            dateFrom: dateFrom,
            dateTo: dateTo,
            userId: user,
            orgUnitId: orgUnit,
            app: ApplicationEnum.GEMINI
        });
    };
    var handleBarCellClick = function (dataIndex, stack) {
        var _a;
        var row = chartData[dataIndex];
        if (!row) {
            return;
        }
        if (isPeriodView) {
            navigateToEventsLogFromChartPeriodForApp({
                app: ApplicationEnum.GEMINI,
                navigateTo: navigateTo,
                periodIndex: dataIndex,
                periodRow: {
                    period: (_a = row.period) !== null && _a !== void 0 ? _a : row.name,
                    previousPeriodLabel: row.previousPeriodLabel
                },
                dateFrom: dateFrom,
                dateTo: dateTo,
                userId: user,
                orgUnitId: orgUnit,
                stack: stack
            });
            return;
        }
        var _b = getPreviousPeriod(dateFrom, dateTo), prevPeriodDateFrom = _b.prevPeriodDateFrom, prevPeriodDateTo = _b.prevPeriodDateTo;
        var entityId = Number(row.segmentId);
        navigateToEventsLogForApp({
            navigateTo: navigateTo,
            dateFrom: stack === ComparisonPeriod.Current ? dateFrom : prevPeriodDateFrom,
            dateTo: stack === ComparisonPeriod.Current ? dateTo : prevPeriodDateTo,
            userId: data.view === GeminiGroupedChartViewEnum.USER ? entityId : user,
            orgUnitId: data.view === GeminiGroupedChartViewEnum.TEAM ? entityId : orgUnit,
            app: ApplicationEnum.GEMINI
        });
    };
    var stackedBarCellProps = function (dataIndex, stack) { return ({
        onClick: function () { return handleBarCellClick(dataIndex, stack); },
        style: { cursor: 'pointer' }
    }); };
    return (_jsxs("div", { children: [_jsx(WidgetTitle, { title: "".concat(I18N, ".title"), description: "".concat(I18N, ".tooltip"), insightType: InsightTypeEnum.geminiUsageLevelDistribution, insightsData: data, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t("".concat(I18N, ".title")), onExportHandler: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2 /*return*/, exportRows];
                    }); }); }, disabled: isAiButtonDisabled(data) }) }), _jsx(ChartSeriesVisibility, __assign({ seriesKeys: GEMINI_USAGE_LEVELS }, { children: function (_a) {
                    var toggleSeries = _a.toggleSeries, isSeriesVisible = _a.isSeriesVisible;
                    return (_jsxs(Widget, __assign({ cardClassName: "shadow overflow-x-auto lg:overflow-visible border-b border-gray-200 sm:rounded-lg p-6", className: "lock w-full max-w-full py-2 align-middle sm:px-6 lg:pl-2 lg:pr-2" }, { children: [_jsx(ClickableGeminiUsageLevelLegend, { t: t, toggleSeries: toggleSeries, isSeriesVisible: isSeriesVisible, items: legendItems, onValueClick: navigateToGeminiEventsLog }), _jsx(WidgetChartPlotArea, __assign({ isEmpty: chartPlotEmpty }, { children: _jsx(ResponsiveContainer, __assign({ width: "100%", height: 400 }, { children: _jsxs(BarChart, __assign({ data: chartData, barGap: barGap, barSize: barSize, margin: periodBarChartMargin }, { children: [_jsx(CartesianGrid, { strokeDasharray: "3 3", stroke: "#f3f4f6" }), _jsx(XAxis, __assign({ dataKey: "name", axisLine: false, tickLine: false }, periodXAxis)), _jsx(YAxis, { axisLine: false, tickLine: false, tick: { fontSize: 12, fill: '#6b7280' }, width: 48, domain: [0, 100], tickFormatter: function (value) { return "".concat(value, "%"); } }), _jsx(Tooltip, { allowEscapeViewBox: { x: true, y: true }, content: renderTooltip }), GEMINI_USAGE_LEVEL_DISTRIBUTION_BAR_CHART_CONFIGS.previous.map(function (config, index) {
                                                var level = GEMINI_USAGE_LEVELS[index];
                                                return (_jsx(Bar, __assign({}, config, { name: seriesLabelFormatter(config.dataKey), hide: !isSeriesVisible(level) }, { children: renderStackedBarCells({
                                                        chartData: chartData,
                                                        stackDataKeys: GEMINI_USAGE_LEVEL_DISTRIBUTION_PREVIOUS_STACK_DATA_KEYS,
                                                        segmentIndex: index,
                                                        keyPrefix: "prev-".concat(config.dataKey),
                                                        getCellProps: function (_entry, dataIndex) {
                                                            return stackedBarCellProps(dataIndex, ComparisonPeriod.Previous);
                                                        }
                                                    }) }), config.dataKey));
                                            }), GEMINI_USAGE_LEVEL_DISTRIBUTION_BAR_CHART_CONFIGS.current.map(function (config, index) {
                                                var level = GEMINI_USAGE_LEVELS[index];
                                                return (_jsx(Bar, __assign({}, config, { name: seriesLabelFormatter(config.dataKey), hide: !isSeriesVisible(level) }, { children: renderStackedBarCells({
                                                        chartData: chartData,
                                                        stackDataKeys: GEMINI_USAGE_LEVEL_DISTRIBUTION_CURRENT_STACK_DATA_KEYS,
                                                        segmentIndex: index,
                                                        keyPrefix: "curr-".concat(config.dataKey),
                                                        getCellProps: function (_entry, dataIndex) {
                                                            return stackedBarCellProps(dataIndex, ComparisonPeriod.Current);
                                                        }
                                                    }) }), config.dataKey));
                                            }), showTeamAverage
                                                ? GEMINI_USAGE_LEVEL_DISTRIBUTION_BAR_CHART_CONFIGS.team.map(function (config, index) {
                                                    var level = GEMINI_USAGE_LEVELS[index];
                                                    return (_jsx(Bar, __assign({ dataKey: config.dataKey, stackId: config.stackId, fill: rechartsDiagonalStripeFillUrl(geminiUsageLevelDistributionTeamStripePatternId(config.dataKey)), name: seriesLabelFormatter(config.dataKey), hide: !isSeriesVisible(level) }, { children: renderStackedBarCells({
                                                            chartData: chartData,
                                                            stackDataKeys: GEMINI_USAGE_LEVEL_DISTRIBUTION_TEAM_STACK_DATA_KEYS,
                                                            segmentIndex: index,
                                                            keyPrefix: "team-".concat(config.dataKey),
                                                            getCellProps: function (_entry, dataIndex) {
                                                                return stackedBarCellProps(dataIndex, ComparisonPeriod.Current);
                                                            }
                                                        }) }), config.dataKey));
                                                })
                                                : null, rechartsDiagonalStripePatternDefs(teamStripePatterns)] })) })) }))] })));
                } }))] }));
}
